import { useEditor } from "@grapesjs/react";
import {
  PlusCircle,
  RefreshCcw01,
} from "@hl/base-components/lib/assets/icons/HDS/";
import { ActionIcon, Box, Group, Stack, Text } from "@mantine/core";
import {
  Property,
  PropertyComposite,
  PropertyNumber,
  PropertyRadio,
  PropertySelect,
  PropertySlider,
  PropertyStack,
} from "grapesjs";

import { ColorPropertyField } from "../property-fields/ColorPropertyField";
import { CompositePropertyFields } from "../property-fields/CompositePropertyFields";
import { FilePropertyField } from "../property-fields/FilePropertyField";
import { NumberPropertyField } from "../property-fields/NumberPropertyField";
import { RadioPropertyField } from "../property-fields/RadioPropertyField";
import { SelectPropertyField } from "../property-fields/SelectPropertyField";
import { SliderPropertyField } from "../property-fields/SliderPropertyField";
import { StackedPropertyFields } from "../property-fields/StackedPropertyFields";
import { TextPropertyField } from "../property-fields/TextPropertyField";

interface StylePropertyFieldProps extends React.HTMLProps<HTMLDivElement> {
  prop: Property;
}

export const CustomStylePropertyField = ({ prop }: StylePropertyFieldProps) => {
  const editor = useEditor();
  // const propType = prop.getType();
  // const propValue = prop.getValue();

  // const [tempValue, setTempValue] = useState<string>(propValue);

  // useEffect(() => {
  //   if (propType !== "number") return;

  //   if (propValue !== tempValue) {
  //     console.log("oh no", { propValue, tempValue });
  //     setTempValue(propValue);
  //   }
  // }, [propType, propValue]);

  if (prop.attributes.visible === false) {
    return null;
  }

  const handleChange = (value: string | null) => {
    if (value == null) return;
    console.log("🍓 Custom Style handle change", { value });
    prop.upValue(value);
  };

  const openAssets = () => {
    const { Assets } = editor;
    Assets.open({
      select: (asset, complete) => {
        console.log({ complete });
        prop.upValue(asset.getSrc(), { partial: !complete });
        complete && Assets.close();
      },
      types: ["image"],
      accept: "image/*",
    });
  };

  const inputProps = {
    type: prop.getType(),
    value: prop.getValue(),
    defaultValue: prop.getDefaultValue(),
    hasValue: prop.hasValue(),
    onChange: (value: string | null) => {
      if (value == null) return;
      if (value.endsWith(".") || value.endsWith(",")) {
        handleChange(value + "1");
        return;
      }
      handleChange(value);
    },
  };

  const type = prop.getType();
  const canClear = prop.canClear();

  let inputToRender = <Box>unknown ${type}</Box>;

  switch (type) {
    case "text": {
      inputToRender = <TextPropertyField {...inputProps} />;
      break;
    }

    case "number": {
      const castedProp = prop as PropertyNumber;
      // console.log("bab", { tempValue });
      inputToRender = (
        <NumberPropertyField
          {...inputProps}
          // value={tempValue}
          // defaultValue={prop.getDefaultValue()}
          // hasValue={tempValue != null}
          // onChange={(value) => {
          //   console.log("🍓 Custom Style handle change", { value });
          //   setTempValue(value ?? "");
          // }}
          // onEnter={() => {
          //   console.log("propagate value", tempValue);
          // }}
          unit={castedProp.getUnit()}
          units={castedProp.getUnits()}
        />
      );
      break;
    }

    case "radio":
      {
        const castedProp = prop as PropertyRadio;
        inputToRender = (
          <RadioPropertyField
            {...inputProps}
            options={castedProp.getOptions()}
          />
        );
      }
      break;

    case "select":
      {
        const castedProp = prop as PropertySelect;
        inputToRender = (
          <SelectPropertyField
            {...inputProps}
            options={castedProp.getOptions()}
          />
        );
      }
      break;

    case "color":
      {
        inputToRender = <ColorPropertyField {...inputProps} />;
      }
      break;

    case "slider":
      {
        const castedProp = prop as PropertySlider;
        inputToRender = (
          <SliderPropertyField
            {...inputProps}
            min={castedProp.getMin()}
            max={castedProp.getMax()}
            step={castedProp.getStep()}
          />
        );
      }
      break;

    case "file":
      {
        inputToRender = (
          <FilePropertyField {...inputProps} openAssets={openAssets} />
        );
      }
      break;

    case "composite":
      {
        inputToRender = (
          <CompositePropertyFields property={prop as PropertyComposite} />
        );
      }
      break;

    case "stack":
      {
        inputToRender = (
          <StackedPropertyFields property={prop as PropertyStack} />
        );
      }
      break;

    default:
      {
        inputToRender = <Box>unknown ${type}</Box>;
      }
      break;
  }

  return (
    <Box>
      <Stack spacing={0}>
        <Group noWrap position="apart" mih={24} pr={0}>
          <Stack spacing={0}>
            <Text c={"dimmed"} size={"sm"}>
              {prop.getLabel()}
            </Text>
            {/* <Text c={"dimmed"} size={"xs"}>
              {type} - [{prop.getId()}] - v: {"" + !!prop.attributes.visible}
            </Text>
            <Text c={"dimmed"} size={"xs"}>
              {prop.getValue()} - {prop.getDefaultValue()} -{" "}
              {"" + prop.hasValue()}
            </Text> */}
          </Stack>

          <Group spacing={"xs"}>
            {canClear && (
              <ActionIcon onClick={() => prop.clear()} size={18} c={"gray.5"}>
                <RefreshCcw01 />
              </ActionIcon>
            )}

            {type === "stack" && (
              <ActionIcon
                onClick={() => (prop as PropertyStack).addLayer({}, { at: 0 })}
                size={18}
                c={"green.6"}
              >
                <PlusCircle />
              </ActionIcon>
            )}
          </Group>
        </Group>

        <Box pl={0}>{inputToRender}</Box>
      </Stack>
    </Box>
  );
};
